import { clientApi } from 'shared/api/clientApi.ts'
import { refreshOrdersCount } from 'shared/api/orders-count-query'
import {
  CreateTourAppealFormShort,
  FormTouristValuesMutation,
  LastTourAppealResponse,
  TourAppealDetails,
  TourAppealListResponse,
  TourTicketParams,
} from 'shared/api/tours/buy-ticket/model.ts'
import { Response } from 'shared/models/general.ts'

export const BuyTourTicketApi = {
  getLastTourAppeal(signal?: AbortSignal) {
    return clientApi.get<Response<LastTourAppealResponse>>(
      'tours/appeal-last',
      {
        signal,
      },
    )
  },
  getValidation(data: FormTouristValuesMutation) {
    return clientApi.post<Response<FormTouristValuesMutation>>(
      `tours/andromeda/validate-personal-data`,
      data,
    )
  },

  createTourAppeal(data: CreateTourAppealFormShort) {
    return clientApi.post<Response<TourAppealDetails>>('tours/appeal', data)
  },

  getTourAppeal(id: string) {
    return clientApi.get<Response<TourAppealDetails>>(`tours/appeals/${id}`)
  },

  async confirmAppeal(id: string) {
    const response = await clientApi.patch(`tours/appeal/${id}/confirm`)
    void refreshOrdersCount()
    return response
  },

  getTourAppealList(params: TourTicketParams) {
    return clientApi.get<TourAppealListResponse>(
      'tours/andromeda/get-tour-appeal-list/',
      {
        params,
      },
    )
  },
}
